<template>
  <v-container class="px-0">
    <CSATRating 
      page-name="Grupos" 
      :pergunta-id="12"
      :delay-seconds="5"
      @rating-submitted="onRatingSubmitted"
    />
    
    <v-row class="d-flex align-center justify-center">
      <v-col cols="12" md="9" class="d-flex align-center justify-center">
        <v-text-field v-model="searchArquivos" clearable color="#6e6e6e" placeholder="Buscar em grupos"
          v-on:keyup.enter="filterTeams" hide-details>
          <template v-slot:append-outer>
            <v-btn @click="filterTeams" text>
              <v-icon class>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="3" class="d-flex justify-end align-center ">
        <v-btn :disabled="(user.plano === `plano-free` || user.plano === null)" @click="showAddGroup = true" color="#F15A24" class="white--text">
          <v-icon color="white">mdi-plus</v-icon>
          Criar novo grupo
        </v-btn>
      </v-col>
    </v-row>
    
    <!-- Seção: Gabinete -->
    <div v-if="gruposGabinete.length > 0" class="mt-6 mb-4">
      <div class="d-flex align-center mb-3">
        <v-icon color="#F15A24" size="24" class="mr-2">mdi-office-building</v-icon>
        <h2 class="mb-0" style="color: #F15A24; font-size: 1.5rem; font-weight: 600;">Gabinete</h2>
      </div>
      <v-row>
        <v-col cols="12" xl="3" md="4" sm="6" v-for="team in gruposGabinete" :key="team.grupos_id.id">
          <v-card v-if="team.grupos_id" 
            class="mx-auto grupo-card grupo-gabinete"
            elevation="2" 
            outlined>
            <v-list-item three-line>
              <v-list-item-content style="align-self: auto;">
                <v-list-item-title class="d-flex align-center flex-wrap mb-1" style="font-size: 1rem !important;">
                  <router-link :to="`/painel/grupo/${team.grupos_id.id}`" class="mr-2" style="flex: 0 1 auto;">
                    {{ team.grupos_id.nome_grupo }}
                  </router-link>
                  <v-chip 
                    x-small
                    outlined
                    color="#F15A24" 
                    text-color="#F15A24" 
                    class="ml-1"
                    style="font-weight: 500; flex-shrink: 0; border-width: 1px;">
                    Gabinete
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle> {{ team.grupos_id.integrantes.length }} participantes</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="100" class="mt-0 rounded-sm">
                <v-img contain v-if="team.grupos_id.imagem_grupo" width="100px" height="auto" class="rounded-sm"
                  :src="`https://api.mylegis.com.br/assets/${team.grupos_id.imagem_grupo}`" />
              </v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn :to="`/painel/grupo/${team.grupos_id.id}`"
                style="background-color: #fff; border: 1px solid #F15A24; border-radius: 5px; color: #F15A24; padding: 5px 10px;"
                small>
                Abrir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Seção: Eleitores -->
    <div v-if="gruposEleitores.length > 0" class="mt-6 mb-4">
      <div class="d-flex align-center mb-3">
        <v-icon color="#4CAF50" size="24" class="mr-2">mdi-account-group</v-icon>
        <h2 class="mb-0" style="color: #4CAF50; font-size: 1.5rem; font-weight: 600;">Eleitores</h2>
      </div>
      <v-row>
        <v-col cols="12" xl="3" md="4" sm="6" v-for="team in gruposEleitores" :key="team.grupos_id.id">
          <v-card v-if="team.grupos_id" 
            class="mx-auto grupo-card grupo-eleitores"
            elevation="2" 
            outlined>
            <v-list-item three-line>
              <v-list-item-content style="align-self: auto;">
                <v-list-item-title class="d-flex align-center flex-wrap mb-1" style="font-size: 1rem !important;">
                  <router-link :to="`/painel/grupo/${team.grupos_id.id}`" class="mr-2" style="flex: 0 1 auto;">
                    {{ team.grupos_id.nome_grupo }}
                  </router-link>
                  <v-chip 
                    x-small
                    outlined
                    color="#4CAF50" 
                    text-color="#4CAF50" 
                    class="ml-1"
                    style="font-weight: 500; flex-shrink: 0; border-width: 1px;">
                    Eleitores
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle> {{ team.grupos_id.integrantes.length }} participantes</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="100" class="mt-0 rounded-sm">
                <v-img contain v-if="team.grupos_id.imagem_grupo" width="100px" height="auto" class="rounded-sm"
                  :src="`https://api.mylegis.com.br/assets/${team.grupos_id.imagem_grupo}`" />
              </v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn :to="`/painel/grupo/${team.grupos_id.id}`"
                style="background-color: #fff; border: 1px solid #F15A24; border-radius: 5px; color: #F15A24; padding: 5px 10px;"
                small>
                Abrir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Seção: Individuais -->
    <div v-if="gruposIndividuais.length > 0" class="mt-6 mb-4">
      <div class="d-flex align-center mb-3">
        <v-icon color="#6e6e6e" size="24" class="mr-2">mdi-folder-account</v-icon>
        <h2 class="mb-0" style="color: #6e6e6e; font-size: 1.5rem; font-weight: 600;">Individuais</h2>
      </div>
      <v-row>
        <v-col cols="12" xl="3" md="4" sm="6" v-for="team in gruposIndividuais" :key="team.grupos_id.id">
          <v-card v-if="team.grupos_id" 
            class="mx-auto grupo-card grupo-individual"
            elevation="2" 
            outlined>
            <v-list-item v-if="(user.plano === `plano-free` || user.plano === null)">
              <small class="mr-1">Ative ja seu  <router-link style="color:#f57029" to="/painel/perfil">Plano Carreira</router-link> para criar novos grupos privados.</small>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content style="align-self: auto;">
                <v-list-item-title class="d-flex align-center flex-wrap mb-1" style="font-size: 1rem !important;">
                  <router-link :to="`/painel/grupo/${team.grupos_id.id}`" class="mr-2" style="flex: 0 1 auto;">
                    {{ team.grupos_id.nome_grupo }}
                  </router-link>
                </v-list-item-title>
                <v-list-item-subtitle> {{ team.grupos_id.integrantes.length }} participantes</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="100" class="mt-0 rounded-sm">
                <v-img contain v-if="team.grupos_id.imagem_grupo" width="100px" height="auto" class="rounded-sm"
                  :src="`https://api.mylegis.com.br/assets/${team.grupos_id.imagem_grupo}`" />
              </v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
              <v-btn :to="`/painel/grupo/${team.grupos_id.id}`"
                style="background-color: #fff; border: 1px solid #F15A24; border-radius: 5px; color: #F15A24; padding: 5px 10px;"
                small>
                Abrir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Mensagem quando não há grupos -->
    <div v-if="gruposGabinete.length === 0 && gruposEleitores.length === 0 && gruposIndividuais.length === 0" class="mt-6 text-center">
      <v-icon color="grey" size="64">mdi-account-group</v-icon>
      <p class="grey--text mt-4">Você ainda não faz parte de grupos</p>
    </div>
    <v-dialog width="500px" v-model="showAddGroup">
      <v-card>
        <v-card-title><v-icon>mdi-plus</v-icon> Criar Novo Grupo</v-card-title>
        <v-card-text>
          <h3><v-icon small>mdi-pencil</v-icon> Nome do Grupo</h3>
          <v-text-field color="#F15A24" v-model="newGroup.nome_grupo"></v-text-field>

          <h3><v-icon small>mdi-image</v-icon> Imagem <small>(opcional)</small></h3>
          <v-file-input color="#F15A24" v-model="newGroup.imagem" label="Selecione o arquivo"></v-file-input>

          <h3 v-if="user.plano === `plano-premium`"><v-icon small>mdi-lock</v-icon> Restrito</h3>
          <v-checkbox v-if="user.plano === `plano-premium`" color="#F15A24" v-model="newGroup.restrito"
            label="Grupo Restrito (participantes não podem exportar conteúdos do grupo)" />
        </v-card-text>
        <v-card-actions class="text-center">
          <v-btn color="#F15A24" class="mx-auto" :loading="loadingNewGroup" dark
            @click="createGroup"><v-icon>mdi-plus</v-icon>Criar Grupo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
a {
  color: #f15a24 !important;
  text-decoration: none;
  word-break: break-word;
}

.grupo-card {
  transition: all 0.3s ease;
}

.grupo-gabinete {
  border-left: 3px solid #F15A24 !important;
  background-color: #fefefe;
}

.grupo-gabinete:hover {
  box-shadow: 0 2px 4px rgba(241, 90, 36, 0.15) !important;
}

.grupo-eleitores {
  border-left: 3px solid #4CAF50 !important;
}

.grupo-eleitores:hover {
  box-shadow: 0 2px 4px rgba(76, 175, 80, 0.15) !important;
}

.grupo-individual {
  border-left: 3px solid #e0e0e0 !important;
}

.grupo-individual:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.v-list-item-title {
  line-height: 1.5 !important;
}

.v-list-item-title a {
  display: inline-block;
  max-width: 100%;
}
</style>

<script>
import CSATRating from '@/components/CSATRating.vue'

export default {
  name: "Equipes",
  components: {
    CSATRating
  },
  data() {
    return {
      selected: 0,
      items: [],
      teams: [],
      filtredTeams: [],
      loadingArquivos: false,
      searchArquivos: null,
      order: "DESC",
      page: 1,
      perPage: 5,
      totalPalavras: 0,
      totalPalavrasFiltrado: 0,
      buscou: false,
      showAddGroup: false,
      loadingNewGroup: false,
      newGroup: { nome_grupo: "", restrito: false }
    };
  },
  mounted() {
    this.reloadEquipes();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    grupos() {
			return this.$store.state.user.grupos
		},
    gruposGabinete() {
      return this.filtredTeams.filter(team => 
        team.grupos_id && this.isGabineteGroup(team.grupos_id)
      );
    },
    gruposEleitores() {
      return this.filtredTeams.filter(team => 
        team.grupos_id && this.isEleitoresGroup(team.grupos_id)
      );
    },
    gruposIndividuais() {
      return this.filtredTeams.filter(team => 
        team.grupos_id && 
        !this.isGabineteGroup(team.grupos_id) && 
        !this.isEleitoresGroup(team.grupos_id)
      );
    },
  },
  methods: {
    onRatingSubmitted(data) {
      window.console.log('Avaliação enviada:', data)
    },
    isGabineteGroup(grupo) {
      if (!grupo) return false;
      // Verifica se o tipo_grupo é 'gabinete' ou se o nome contém "Gabinete"
      return grupo.tipo_grupo === 'gabinete' || 
             (grupo.nome_grupo && grupo.nome_grupo.includes('Gabinete'));
    },
    isEleitoresGroup(grupo) {
      if (!grupo) return false;
      // Verifica se o tipo_grupo é 'eleitores' ou se o nome contém "Eleitores"
      return grupo.tipo_grupo === 'eleitores' || 
             (grupo.nome_grupo && grupo.nome_grupo.includes('Eleitores'));
    },
    async uploadFile() {
      let file = this.newGroup.imagem
      const formData = new FormData();
      formData.append('image', file)
      let dt = await this.$http.post('/files', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return dt.data.data
    },
    async createGroup() {
      this.loadingNewGroup = true
      let asset = undefined
      if (this.newGroup.imagem) {
        asset = await this.uploadFile()
      }
      window.console.log(asset)
      if (this.newGroup.nome_grupo == "") { 
        alert("Por favor insira o nome do grupo!")
      this.loadingNewGroup = false

        return
      }
      this.$http.post("/items/grupos", {
        imagem_grupo: asset ? asset.id : undefined,
        nome_grupo: this.newGroup.nome_grupo,
        status: "published",
        restrito: this.newGroup.restrito,
        administradores: [{ directus_users_id: this.$store.state.user.id }],
        integrantes: [{ directus_users_id: this.$store.state.user.id }]
      }).then(() => {
        this.newGroup = {}
        this.loadingNewGroup = false

        this.showAddGroup = false
        this.$store.dispatch('getInfo')
        this.reloadEquipes()
      }).finally(() => {
        this.loadingNewGroup = false

      })
    },
    filterTeams() {
      if (!this.searchArquivos || this.searchArquivos === "") {
        this.filtredTeams = this.teams;
        return;
      }
      this.filtredTeams = this.teams.filter((team) =>
        team.grupos_id && team.grupos_id.nome_grupo &&
        team.grupos_id.nome_grupo
          .toLowerCase()
          .includes(this.searchArquivos.toLowerCase())
      );
    },
    async reloadEquipes() {
      await this.$store.dispatch("getInfo")


      this.teams = this.grupos
      this.filtredTeams = this.grupos.filter((el) => el.grupos_id && el.grupos_id.status === 'published');
    },

    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
};
</script>